/**
 * Fast geografisk avgrensning for korridoren:
 *   Bærums Verk → Oslo vest → Vika / Aker Brygge
 *
 * Dette er IKKE en generell områdevelger – kun én fast korridor
 * som er stor nok til hele ruten.
 */

// [lng, lat]
export const KEY_POINTS = {
  baerumsVerk: [10.50386, 59.94195], // faktisk rutestart (Lommedalsveien)
  baerum: [10.5240, 59.8900],
  lysaker: [10.6360, 59.9130],
  skoyen: [10.6790, 59.9210],
  vika: [10.72273, 59.91091], // faktisk rutestopp Vika Atrium
  akerBrygge: [10.7290, 59.9090],
  oslo: [10.7522, 59.9139],
  oslofjorden: [10.7150, 59.8900],
};

/**
 * Ytre bounding box – konsentrert på Bærum–Oslo, men romslig nok
 * til å ha med HELE Oslo (sentrum/øst + ned mot fjorden), ikke bare
 * ruten som ender i Vika (10.72).
 * Format: [[west, south], [east, north]]
 */
export const CORRIDOR_BOUNDS = [
  [10.49, 59.86], // sørvest (Bærums Verk + fjorden)
  [10.88, 59.97], // nordøst (hele Oslo øst)
];

// Litt luft rundt bounds når vi fitter kameraet.
export const CORRIDOR_FIT_PADDING = 40;

// Begrens panorering – konsentrert rundt Bærum/Oslo, men med hele
// Oslo innenfor (østover til ~10.94, sør til fjorden ~59.82).
export const MAX_BOUNDS = [
  [10.44, 59.82],
  [10.94, 59.99],
];
